import React, { useDispatch } from "reactn"
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerCloseButton,
} from "@chakra-ui/modal"
import {
  Flex,
  Grid,
  GridItem,
  Spacer,
  useBreakpointValue
} from "@chakra-ui/react"
import ShoppingCart from "./shoppingCart"
import CartError from "./cartError"
import Checkout from "./checkout"
import { Box, Menu, Button } from "@chakra-ui/react"
import "./cartSidebar.css"
import {
  ArrowBackIcon,
  ArrowForwardIcon,
  NotAllowedIcon,
} from "@chakra-ui/icons"
import { CartButton } from "../ui/cart-button"
import ShoppingCartFooter from "./shoppingCartFooter"
import ViewHeightComponent from "../utils/viewHeightComponent"
import { Dots } from "./dotsAnimation"
import Promo from "./sections/promo"
import CartUpsells from "./sections/cartUpsells"
import { useOnlineStatus } from "../utils/onlineStatus"
import Div100vh from "react-div-100vh"


export function CartSidebar({ location, globalState }) {
  const { store, updateGlobal } = globalState
  const { cartOpen, checkoutOpen, itemsInCart, calculating, processing } = store
  const fetchCart = useDispatch("fetchCart")
  const isOnline = useOnlineStatus()

  // // Fetch cart data when cart is opened (if not already initialised)
  // React.useEffect(() => {
  //   if (cartOpen && !store.cartInitialised) {
  //     fetchCart()
  //   }
  // }, [cartOpen])

  const splitView = useBreakpointValue([false, false, true, true])
  const size = useBreakpointValue(["full", "full", "md", "md"])
  const sizeOpen = useBreakpointValue(["full", "full", "full", "full"])
  const gridColumns = useBreakpointValue([4, 4, 4, 4, 5])
  const gridSpan = useBreakpointValue([2, 2, 2, 2, 3])

  return (
    <>
      <Drawer
        variant={"secondary"}
        placement={"right"}
        onClose={() => {
          updateGlobal({ cartOpen: false, checkoutOpen: false })
        }}
        isOpen={cartOpen}
        size={checkoutOpen ? sizeOpen : size}
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        <Div100vh>
        <DrawerContent backgroundColor={"white"}>
          <DrawerHeader backgroundColor={"black"} pt={1} minHeight={"56px"}>
            <DrawerCloseButton size={"lg"}mt={0}_focus={{boxShadow: "none"}}color={"white"}border={"none"}outline={"none"}/>
            <Flex>
              <Box color={"white"} mt={2} fontSize={20} fontWeight={400}>
                CHECKOUT
              </Box>
              <Spacer />
              <Box mt={1} mr={4}>
                {checkoutOpen && <CartButton globalState={globalState} />}
              </Box>
            </Flex>
          </DrawerHeader>

          <DrawerBody fontSize={18}
            minHeight={"120dvh !important"}
            height={"120dvh !important"}
            backgroundColor={"white !important"}
            style={{height: '120dvh'}}
          >
             <Box maxH="80vh" >
            <Menu isOpen={cartOpen}id={"cartsidebar"}itemListClassName={"cart-list"}rightpageWrapId={"page-wrap-cart"}outerContainerId={"outer-container-cart"}>
            <Flex height={"100%"} direction={"row"}>
              <Box id="page-content" minWidth={"100%"} >
                <Grid id="grid"templateColumns={`repeat(${checkoutOpen ? (splitView ? gridColumns : 1) : 1}, 1fr)`}gap={splitView ? "20px" : "0px"}>
                  {(!checkoutOpen || (checkoutOpen && splitView)) && (
                    <GridItem maxW="90vw" id="gi1" colSpan={splitView ? 2 : 1}>
                      {itemsInCart ? (
                          <ViewHeightComponent viewHeight={85}>
                          <Box id="shoppingCartx" height={["80vh","80vh","90vh","90vh"]} >
                            <Flex maxHeight={"100%"} minHeight={"100%"} direction={"column"}>
                              <Box flex="1" overflowY={["scroll","scroll","scroll","scroll",]}>
                                <ShoppingCart showSummary={checkoutOpen}globalState={globalState}/>
                              </Box>
                              {!checkoutOpen && (
                                <Box width="95%" maxW={'600px'} >
                                  <CartUpsells globalState={globalState} />
                                  <Promo globalState={globalState} />
                                </Box>
                              )}
                              <Box>
                                {checkoutOpen ? (
                                  <ShoppingCartFooter globalState={globalState}/>
                                ) : (
                                  <>
                                    <CartError />
                                    <Button mb={[5, 5, 0, 0]}type={"button"}variant={"checkout"}isDisabled={!isOnline || processing || calculating}rightIcon={calculating ? (<Dots mt={2} size="xs" />
                                      ) : isOnline ? (
                                        <ArrowForwardIcon />
                                      ) : (
                                        <NotAllowedIcon />
                                      )}
                                      onClick={() => {
                                        updateGlobal({ checkoutOpen: true })
                                        // Prefetch cart data for faster checkout loading
                                        if (store.fetchCart) {
                                          store.fetchCart()
                                        }
                                      }}
                                    >
                                      {calculating ? "" : "CHECKOUT"}
                                    </Button>
                                  </>
                                )}
                              </Box>
                            </Flex>
                          </Box>
                        </ViewHeightComponent>
                      ) : (
                        <ViewHeightComponent viewHeight={85}>
                          <Flex direction={"column"} height={"100%"}>
                            <Box textAlign={"center"} mt={20} flex="1">
                              <Box>YOUR CART IS EMPTY</Box>
                            </Box>
                            <Box>
                              <Button variant="checkout"fontSize={14}leftIcon={<ArrowBackIcon />}
                                onClick={() => updateGlobal({ cartOpen: false })}
                              >
                                CONTINUE SHOPPING
                              </Button>
                            </Box>
                          </Flex>
                        </ViewHeightComponent>
                      )}
                    </GridItem>
                  )}

                  {checkoutOpen && itemsInCart && (
                    <GridItem id="gic"maxW="90vw"colSpan={splitView ? gridSpan : 1}>
                      <ViewHeightComponent viewHeight={85}>
                        <Box id="Checkout" height={["80vh","80vh","80vh","80vh"]} overflowY={['scroll','scroll','unset','unset']}>
                          <Checkout location={location}globalState={globalState}/>
                        </Box>
                      </ViewHeightComponent>
                    </GridItem>
                  )}
                </Grid>
              </Box>
              </Flex>
            </Menu>
            </Box>
          </DrawerBody>
        </DrawerContent>
        </Div100vh>
      </Drawer>
    </>
  )
}